import { useSyncExternalStore } from "react";

const query = "(prefers-reduced-motion: reduce)";
const subscribe = (onChange: () => void) => {
  const media = typeof window !== "undefined" ? window.matchMedia?.(query) : undefined;
  media?.addEventListener("change", onChange);
  return () => media?.removeEventListener("change", onChange);
};
export const prefersReducedMotion = () =>
  typeof window !== "undefined" && Boolean(window.matchMedia?.(query).matches);
// Start with static content during SSR/hydration, then use the live preference.
const serverSnapshot = () => true;
export const usePlaygroundReducedMotion = () =>
  useSyncExternalStore(subscribe, prefersReducedMotion, serverSnapshot);
